// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ToggleFavouriteMutationVariables = Types.Exact<{
  gameId: Types.Scalars['ID']['input'];
}>;


export type ToggleFavouriteMutation = { __typename?: 'Mutation', casinoToggleFavourite?: { __typename?: 'CasinoToggleFavouritePayload', favouriteGameNode?: { __typename?: 'CasinoGame', id: string, isFavourite?: boolean }, errors?: Array<{ __typename?: 'CasinoError', code?: number, message?: string, params?: Array<{ __typename?: 'CasinoErrorParam', name?: string, value?: string }> }> } };


export const ToggleFavouriteMutationDocument = /*#__PURE__*/ gql`
    mutation ToggleFavouriteMutation($gameId: ID!) {
  casinoToggleFavourite(input: {gameId: $gameId}) {
    favouriteGameNode {
      id
      isFavourite
    }
    errors {
      code
      message
      params {
        name
        value
      }
    }
  }
}
    `;
export type ToggleFavouriteMutationMutationFn = Apollo.MutationFunction<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>;
export function useToggleFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>(ToggleFavouriteMutationDocument, options);
      }
export type ToggleFavouriteMutationHookResult = ReturnType<typeof useToggleFavouriteMutation>;
export type ToggleFavouriteMutationMutationResult = Apollo.MutationResult<ToggleFavouriteMutation>;
export type ToggleFavouriteMutationMutationOptions = Apollo.BaseMutationOptions<ToggleFavouriteMutation, ToggleFavouriteMutationVariables>;